import {singleton} from "tsyringe";
import {container} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";
import {OpenNewProjectDialogCommand} from "../open-new-project-dialog.command";
import {ProjectRepository} from "../../domain/repositories/project.repository";
import {DialogHelper} from "../../helpers/dialog.helper";
import {get} from "lit-translate";
import {BOARD_TYPE_PROJECT} from "../../constants";

@CommandHandler(OpenNewProjectDialogCommand)
@singleton()
export class OpenNewProjectDialogCommandHandler implements ICommandHandler<void> {
    
    public async handle(command: ICommand<void>): Promise<void> {
        const projectRepository = container.resolve(ProjectRepository);
        const project = await projectRepository.create(BOARD_TYPE_PROJECT);
        const title = get(`ha-boards-view.add-entity.add-project`);
        const closable = true;
        
        DialogHelper.showDialog(`ha-dialog-project-edit`, {title, project, closable});
    }
}